/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FindUnitTokensRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {FindTokensResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const findUnitTokens = (request: FindUnitTokensRequest, options?: CashRequestOptions) => post<FindUnitTokensRequest, FindTokensResponse>("/2.0/cash/find-unit-tokens", request, {...options, rejectOnError: true })